<template>
  <!-- 这个是题目板块 -->
<!--  练习-->
  <div class="id_3">
<!--    {{isLast}}-->
    <div class="top clear">
      <div class="img_box fl">
        <img ref='img' :src="data.src">
      </div>
      <div class="title bold fl" v-html="data.title"></div>
    </div>
    <!-- 线条 -->
    <div class="border"></div>
    <!-- 题目介绍 -->
    <div class="text" v-if="data.text" v-html="data.text"></div>
    <div class="topic" v-if="bol">
      <div class="topic_list" v-for="(item, index) in list" :key="JSON.stringify(item.questionId) + index" v-if="update">
        <Topic :disabledBol="disabledBol" :data="item" @getTopic="getTopic" :topicList="topicList" :ref="item.questionId"></Topic>
      </div>
    </div>
    <!-- 提交 -->
<!--    <div class="topic_btn" v-if="isLast && btnBol">-->
<!--      <el-button-->
<!--        type="primary"-->
<!--        :title="subHeaderInfo.endTime<nowDate?'提交时间已截止，无法提交':''"-->
<!--        :disabled="disabledBol"-->
<!--        round-->
<!--        @click="toAnwers">-->
<!--        &lt;!&ndash; 有答案的才叫已提交 &ndash;&gt;-->
<!--        {{(modifyBol?'已提交':'提 交')}}-->
<!--      </el-button>-->
<!--      <el-button type="text"-->
<!--        v-if="modifyBol-->
<!--        &&(!subHeaderInfo.endTime || (subHeaderInfo.endTime > nowDate))-->
<!--        &&((this.maxSubmitCount > (this.submitCount - 1))||maxSubmitCount==100)"-->
<!--        @click="toModify">-->
<!--        修改-->
<!--        </el-button>-->
<!--    </div>-->
  </div>
</template>

<script>

import Topic from '../../topic/main'
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    data: Object,
    curriculaId: String,
    isLast: Boolean
  },
  provide () {
    return {
      dataId3: this
    }
  },
  name: 'id_3',
  computed: mapState({
    nowDate: state => state.common.nowDate,             // 当前时间
    subHeaderInfo: state => state.common.subHeaderInfo, // 但前子任务详情
    disabledBol () {
      // 如果当前时间大于了最后提交时间就直接不给提交了
      if (this.subHeaderInfo.endTime && this.subHeaderInfo.endTime < this.nowDate) {
        return true
      }
      // 题目已经有答案了进入修改模式
      if (this.modifyBol) {
        return true
      }
      // isSubmit代表还可以提交么 0不可以，1是可以提交 2是不限次数
      if (+this.isSubmit === 0) {
        return true
      } else if (+this.isSubmit === 1) {
        // 100就是无限提交  要大于提交次数
        if ((this.maxSubmitCount === 100) || (this.maxSubmitCount > (this.submitCount - 1))) {
          return false
        } else {
          return true
        }
      } else if (+this.isSubmit === 2) {
        return this.btnDisabled
      }
      return true
    }
  }),
  data () {
    return {
      contestData: {},       // 赛季详情
      bol: true,
      list: [],
      topicList: null,       // 获取到的题目数组
      btnDisabled: false,    // 按钮是否禁用，返回来的
      isSubmit: 0,           // 按钮状态
      maxSubmitCount: 0,     // 最大提交次数
      submitCount: 0,        // 提交次数
      modifyBol: false,      // 答案存在了，是否进入修改模式
      btnBol: true,           // 是否显示按钮
      update: true,
      Answers: '' // 本模块的答案
    }
  },
  methods: {
    // 统一修改
    toModify () {
      // this.modifyBol = false
      this.$emit('toModify')
    },
    // 统一提交
    toAnwers () {
      this.$emit('toAnwers')
    },
    // 拿到题目后触发
    getTopic (data) {
      // 有答案就进入修改模式
      if (data && data.answered) {
        this.modifyBol = true
        this.$emit('needModify')
      }
      // 按钮是否显示 如果是7之中星星题就不显示提交按钮
      if (data && data.questionType === 7 && this.list.length === 1) {
        this.btnBol = false
      } else if (data && data.questionType === 13 && this.list.length === 1) {
        this.btnBol = false
      }
      // 按钮是否禁用
      if (data && (data.questionType !== 7 || data.questionType !== 13) && data.answered) {
        this.btnDisabled = true
      }
    },
    // 是否显示提交答案
    isSubmitFn () {
      // 如果任务id不存在则不需要进行接口请求
      if (!this.$route.query.taskRelationId) return
      let data = {
        taskRelationId: this.$route.query.taskRelationId,
        taskGroupType: this.subHeaderInfo.taskGroupType,
        taskType: this.subHeaderInfo.taskType,
        seasonId: this.$utils.cache('seasonId')
      }
      // ,
      //   taskGroupType: 1,
      //   seasonId:
      this.$api.post('MANAGE_CHECK_WORK', data, ({data}) => {
        this.isSubmit = data.isSubmit || 0
        this.maxSubmitCount = data.maxSubmitCount || 0
        this.submitCount = data.submitCount || 0
      })
    },
    // 提交答案
    saveAnwers () {
      let arr = []
      for (let i in this.list) {
        // dom元素
        let dom = this.$refs[this.list[i].questionId][0].$el
        // 答案文字
        if (dom.querySelector('.Rate') || dom.querySelector('.Writing')) {   // 星星和写作不用一起提交
          continue
        }
        // 防止删库跑路
        if (!dom.querySelector('.answerObj')) {
          continue
        }
        let txt = dom.querySelector('.answerObj').innerText
        // 1为必做 2位非必做
        let isNecessary = dom.querySelector('.isNecessary').innerText
        // 答案对象
        let obj
        if (txt) {
          obj = JSON.parse(txt)
        } else {
          obj = {}
        }
        // 有没有满足要求的抛错
        if (obj.msg && (+isNecessary === 1)) {
          this.$message({
            showClose: true,
            message: obj.msg,
            type: 'error'
          })
          return
        } else if (obj.msg && (+isNecessary === 0)) {
          continue
        }
        arr.push(obj)
      }
      let data = {
        taskRelationId: this.$route.query.taskRelationId,
        answerDtoList: arr,
        taskGroupType: this.subHeaderInfo.taskGroupType,
        taskType: this.subHeaderInfo.taskType,
        taskTitle: this.subHeaderInfo.taskTitle,
        topicId: this.subHeaderInfo.topicId,
        topicType: this.subHeaderInfo.topicType,
        contestEn: this.contestData.nameEn,
        seasonId: this.$utils.cache('seasonId')
      }
      this.Answers = data
      this.$emit('collectAnswers', arr)
    },
    // 提交答案
    pushAnswer (data) {
      this.list = []
      this.$api.post('SAVE_CURRICULA_ANSWER', data, ({ data }) => {
        this.$message({
          showClose: true,
          message: '提交成功',
          type: 'success'
        })
        // this.getAnwers(data)
        // 重新获取题目
        this.topicList = data
        // 提交次数加1
        this.submitCount++
        // 触发刷新子任务列表
        this.set_SubListUpdate()
        this.init()
        // document.location.reload()
      })
    },
    // 触发刷新子任务列表
    ...mapMutations([
      'set_SubListUpdate'
    ]),
    // 获取全部题目
    getTopicList () {
      // 如果任务id不存在则不需要进行接口请求
      // isOpenAi  本题目模块是否有开启ai的
      if (!this.$route.query.taskRelationId) return
      let data = {
        questionIds: this.data.questionId.split(','),
        taskRelationId: this.$route.query.taskRelationId,
        taskGroupType: this.subHeaderInfo.taskGroupType,
        seasonId: this.$utils.cache('seasonId')
      }
      this.$api.post('TEST_GET_ALL_QUESTIONS', data, (res) => {
        this.topicList = res.data
      })
    },
    // 获取赛季详情
    getContest () {
      let obj = {
        seasonId: this.$utils.cache('seasonId')
      }
      this.$getCommon('NEW_CONTEST_SEASON_GETINFO', obj).then(({ data }) => {
        this.contestData = data || {}
      })
    },
    // 初始化
    init () {
      this.isSubmitFn()
      if (!this.data.questionId) {
        return
      }
      let arr = this.data.questionId.split(',')
      for (let i in arr) {
        this.list.splice(this.list.length, 0, {questionId: arr[i]})
      }
      this.getTopicList()
      this.getContest()
    },
    // 重新拉取题目
    getAnwers () {
      this.bol = false
      setTimeout(() => {
        this.bol = true
      }, 17)
    }
  },
  created () {
    this.init()
  },
  components: {
    Topic
  }
}
</script>

<style lang="scss">
.id_3{
  word-wrap:break-word;
  >.text{
    .text_title:nth-of-type(1){
      font-size: 18px;
      line-height: 25px;
      margin-top: 32px;
      span{
        font-weight: 500;
        font-size: 12px;
        color: #8f8f8f;
        line-height: 17px;
        margin-left: 8px;
      }
    }
    .text_title:nth-of-type(2){
      margin-top: 8px;
      font-size: 14px;
      color: #606266;
      line-height: 22px;
    }
  }
}
</style>

<style lang="scss" scoped>
.id_3{
  margin: 24px 0 ;
  padding-bottom: 32px;
  background-color: #fff;
  border-radius: 4px;
  .top{
    padding: 20px 0;
    position: relative;
    .img_box{
      width: 32px;
      height: 28px;
      margin-right: 13px;
      img{
        height: 100%;
        width: 100%;
      }
    }
    .title{
      line-height: 28px;
      font-size: 18px;
    }
  }
  .border{
    width: calc(100% + 80px);
    border-bottom: 1px #EBEEF5 solid;
    margin-left: -40px;
  }
  .topic{
    .topic_list{
      .add{
        text-align: center;
        margin-top: 16px;
      }
    }
    .no_list{
      padding-top: 16px;
      text-align: center;
    }
  }
  .topic_btn{
    text-align: center;
    margin-top: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_3.vue